export default __webpack_public_path__ + "6fd7431272bb618da14e6e1b7c0b24fe.png";